/* eslint-disable no-undef */
import Vue from "vue"
import ApiUrl from "../apiurl"

export default {
	namespaced: true,
	state: {
		searchType: Number,
		currentPage: 1,
		//   page:1,
		searchKey: "",
		defauleSearchSchema: {
			defaultFilter: [
				{ label: "专利有效性", key: "legalStatus", size: 10 },
				{ label: "当前法律状态", key: "currentStatus", size: 10 },
				{ label: "申请日", key: "applicationYear", size: 10 },
				{ label: "公布(公告)日", key: "documentYear", size: 10 },
				{ label: "文献类型", key: "kindCode", size: 10 },
				{ label: "申请人", key: "applicant", size: 10 },
				{ label: "申请人类型", key: "applicantType", size: 10 },
				{ label: "申请人所在国/区域", key: "applicantCountryCode", size: 10 },
				{ label: "发明人", key: "inventor", size: 10 },
				{ label: "第一发明人", key: "firstInventor", size: 10 },
				{ label: "专利权人", key: "assignee", size: 10 },
				{ label: "代理机构", key: "agency", size: 10 },
				{ label: "代理人", key: "agent", size: 10 },
				{ label: "IPC", key: "ipc", size: 10 },
				{ label: "IPC部", key: "ipc1", size: 10 },
				{ label: "IPC大类", key: "ipc2", size: 10 },
				{ label: "IPC小类", key: "ipc3", size: 10 },
				{ label: "IPC大组", key: "ipc4", size: 10 },
				{ label: "IPC小组", key: "ipc5", size: 10 },
				{ label: "PCT", key: "pct", size: 10 },
				{ label: "外观分类", key: "loc", size: 10 },
				{ label: " 省(中国)", key: "province", size: 10 },
				{ label: " 市(中国)", key: "city", size: 10 },
				{ label: " 专利评级", key: "level", size: 10 },
				{ label: "  法律事件", key: "legalEvent", size: 10 },
				{ label: "复审无效合议组组长", key: "reexamination.teamLeader", size: 10 },
				{ label: "复审无效审查员", key: "reexamination.primaryExaminer", size: 10 },
				{ label: "无代理机构", key: "missing_agency", size: 10 }
			],
			displayModes: [
				{
					name: "mix",
					pageSize: 10,
					label: "图文混合"
				},
				{
					name: "list",
					pageSize: 20,
					label: "列表展现"
				},
				{
					name: "image",
					pageSize: 16,
					label: "图片显示"
				},
				{
					name: "duplex",
					pageSize: 20,
					label: "双联排版"
				}
			],
			defaultDisplayMode: "mix"
		},
		// 保存的搜索方案
		savedSearchSchemas: [],
		countryFilter: []
	},
	getters: {
		defauleSearchSchema: (state) => {
			return state.defauleSearchSchema
		},
		currentPage: (state) => {
			return state.currentPage
		},
		// 保存的搜索方案
		savedSearchSchemas: (state) => {
			return state.savedSearchSchemas
		},
		//专利信息

		getSavedSearchSchema: (state, name) => {
			return function(key) {
				let i = state.savedSearchSchemas.findIndex((item) => item.key && item.key === key)
				if (i === -1) {
					return []
				} else {
					return state.savedSearchSchemas[i]["buckets"]
				}
			}
		},
		countryFilter: (state) => {
			return state.countryFilter
		}
	},
	mutations: {
		setCurrentPage(state, newValue) {
			state.currentPage = newValue
		},
		// 设置保存搜索方案
		setSavedSearchSchemas(state, newValue) {
			if (Array.isArray(newValue)) {
				console.log(newValue)
				Vue.set(state, "savedSearchSchemas", [...newValue])
			}
		},
		upsertSavedSearchSchema(state, newValue) {
			if (newValue && newValue.key) {
				let i = state.savedSearchSchemas.findIndex((item) => item.key && item.key === newValue.key)
				if (i === -1) {
					state.savedSearchSchemas.push(newValue)
				} else {
					Vue.set(state.savedSearchSchemas, i, { ...newValue })
				}
			}
		},
		setcountryFilter(state, newValue) {
			state.countryFilter = newValue
		},
		setSearchType(state, newValue) {
			state.searchType = newValue
		},
		setSearchKey(state, newValue) {
			state.searchKey = newValue
		}
	},
	actions: {
		async queryAggs({ commit }, { params, handle }) {
			console.log(params,2000)
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.aggs, { params: params })
				if (rsp && rsp.data) {
					console.log(rsp.data, "===(rsp.data===",ApiUrl.search.aggs)
					var saveSchema = {}
					var countryFilter = []
					saveSchema["key"] = rsp.data.name
					saveSchema["buckets"] = rsp.data.buckets
					commit("upsertSavedSearchSchema", saveSchema)
					if (rsp.data.name == "countryCode") {
						countryFilter = rsp.data.buckets
						let list = [...countryFilter]
						if (list.length > 0) {
							list.forEach((item) => {
								let child = item.children[0].buckets
								let total = []
								if (child && child.length > 0) {
									child.forEach((item1) => {
										let temp = item.key + "_" + item1.key
										total.push(temp)
									})
									item.total = total
								}
							})
						}
						commit("setcountryFilter", countryFilter)
					}
					handle && handle(rsp.data)
				}
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		// sb?q=石墨烯&t=123
		async querySearch({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.skey, data)
				console.log(data, "====data=====")
				//table表格的数据
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		//专利的数据
		async partedSearch({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.parted, data)
				console.log(data, "====data=====")
				//table表格的数据
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async querySug({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.sug, data)
				// if (rsp && rsp.data) {
				console.log(data, "====data2=====")

				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getSearchInfo({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.info, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentClaims({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.claims, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentDesp({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.description, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentDraw({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.drawings, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentInfo({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.info1, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentLike({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.like, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentPdf({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.pdf, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentFamily({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.family, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentExtendedFamily({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.extendedFamily, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentCiting({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.citing, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentTransAction({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.transaction, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPatentLaw({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})

				const rsp = await axios.get(ApiUrl.search.law, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async joinSpace({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.joinSpace, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async createPdfFile({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(data.url, data.data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async saveStrategy({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.search.saveStrategy, null, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getStrategy({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.strategyList, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async renameStrategy({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.put(ApiUrl.search.strategyEdit, null, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async delStrategy({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.delete(ApiUrl.search.saveStrategy, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async mergeStrategy({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.search.strategyMerge, null, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async strategyView({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.search.strategyView, null, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async strategyCount({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.strategyCount, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getHistoryList({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.historyList, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getPdfDown({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.pdfDown + "/" + data.url + "/pdf/d", data.data1)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getMultiplePdf({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.pdfDown1, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getTaskProgress({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.taskPro + data.id + "/progress", data.data1)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getWriteFile({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.zhulu, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getSearchLike({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.search.searchLike, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getSearchImg({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.search.img, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async imgUpload({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.search.upload, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async delHistory({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.delete(ApiUrl.search.delshv, data)
				// if (rsp && rsp.data) {
				handle && handle(rsp.data)
				// }
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getIpcList({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.ipcList, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getIpcChildList({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.ipcChild, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getCompList({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.comp, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getCompListChild({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.search.compChild, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		}
	}
}
